import {
  Condition,
  NumItemsBeingReturnedOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface ItemsBeingReturnedCountState {
  numItemsOption: NumItemsBeingReturnedOption;
  numItems: string;
}

export const ITEMS_BEING_RETURNED_COUNT = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<ItemsBeingReturnedCountState>
  >,
): ConditionType<
  ItemsBeingReturnedCountState,
  Condition.ItemsBeingReturnedCount
> => ({
  name: "Number of items being returned",
  description(state) {
    return `Number of items ${state.numItemsOption.toLowerCase()} ${state.numItems}`;
  },
  Details(props: ConditionTypeDetailsProps<ItemsBeingReturnedCountState>) {
    return React.createElement(Details, props);
  },
  empty: { numItemsOption: NumItemsBeingReturnedOption.EQUALS, numItems: "1" },
  fromModel(model) {
    return {
      numItemsOption: model.numItemsOption,
      numItems: model.numItems.toFixed(0),
    };
  },
  toModel(state) {
    return {
      type: Condition.ITEMS_BEING_RETURNED_COUNT,
      numItemsOption: state.numItemsOption,
      numItems: +state.numItems,
    };
  },
  valid(state) {
    return +state.numItems >= 0 && +state.numItems % 1 === 0; // Must be whole number
  },
});
